import {AbstractPmsApiService} from './abstract.service';
import {NTMPFinancialSetting, NTMPFinanceFacilitySetting} from '../models';

export class NTMPFinancialSettingPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/ntmp-financial-setting';
    }

    newModel(attributes) {

        return new NTMPFinancialSetting(attributes);
    }

    get() {

        return this.http
            .get(this.url(), {headers: this.authHeaders})
            .then(response => response.data ? this.newModel(response.data) : null)
            .catch(this.getErrorHandler());
    }

    save(settings) {

        const payload = settings.toObject('integration_key', 'integration_secret', 'is_active');

        return this.http
            .post(this.url(), payload, {headers: this.authHeaders})
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}

export class NTMPFinanceFacilitySettingPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/property/:propertyId/ntmp-finance-facility-setting';
    }

    newModel(attributes) {

        return new NTMPFinanceFacilitySetting(attributes);
    }

    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {headers: this.authHeaders})
            .then(response => response.data ? this.newModel(response.data) : null)
            .catch(this.getErrorHandler());
    }

    save(property, settings) {

        const url = this.url({propertyId: property.id});
        const payload = settings.toObject('facility_id', 'facility_secret', 'is_active');

        return this.http
            .post(url, payload, {headers: this.authHeaders})
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}

export class NTMPAccountCatalogPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/ntmp-account-catalog/:type-accounts';
    }

    getRevenueAccounts() {

        return this.getAccounts('revenue');
    }

    getExpenseAccounts() {

        return this.getAccounts('expense');
    }

    getAccounts(type) {

        return this.http
            .get(this.url({type}), {headers: this.authHeaders})
            .then(this.getDataExtractor())
            .then(accounts => accounts.map(account => Object.assign({}, account, {
                accountNumber: String(account.accountNumber)
            })))
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/ntmp-financial-setting.service.js